import React from "react";
import { __ } from "@wordpress/i18n";
import { getUtmUrl } from "../../utils/utm-url";

const Footer = () => {
  return (
    <div className="cross-sell-footer">
      <div className="cross-sell-wrapper cross-sell-footer__wrapper">
        <div className="cross-sell-footer__content">
          <div className="cross-sell-footer__title">
            <h2>{__("About WPMU DEV", "plugin-cross-sell-textdomain")}</h2>
            <p>
              {__(
                "Made for web developers, by web developers",
                "plugin-cross-sell-textdomain"
              )}
            </p>
          </div>
          <div className="cross-sell-footer__description">
            <p>
              {__(
                "Since 2006, our award-winning WordPress plugins, hosting, world beating support and site management tools have helped hundreds of thousands of web developers, freelancers and agencies run and grow their businesses. ",
                "plugin-cross-sell-textdomain"
              )}
              <a
                href={getUtmUrl("https://wpmudev.com/about/", {utm_campaign:'cross-sell_learn-more'})}
                target="_blank"
                className="cross-sell-link"
              >
                {__("Learn more", "plugin-cross-sell-textdomain")}
              </a>
            </p>
          </div>
        </div>
        <div className="cross-sell-footer__credits">
          <p>
            {__(
              "Everything Wordpress found in one place. ",
              "plugin-cross-sell-textdomain"
            )}
            <a
              href={getUtmUrl("https://wpmudev.com/", {utm_campaign:'cross-sell_footer-link'})}
              target="_blank"
              className="cross-sell-link"
            >
              {__("WPMU DEV", "plugin-cross-sell-textdomain")}
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export { Footer };
